/**
 * Client-safe session shape shared by the server resolver and the client
 * fetcher. Intentionally minimal and fully serializable (no `Date` fields) so it
 * crosses the SSR dehydrate/hydrate boundary and lives on the router context
 * cleanly. The auth gate only needs identity; richer session fields stay on the
 * server.
 */
export interface AppSession {
  readonly user: {
    readonly id: string;
    readonly email: string;
    readonly name: string;
    readonly image: string | null;
    /** Whether the email has been verified — the onboarding gate keys off this. */
    readonly emailVerified: boolean;
  };
}

/** Normalizes a BetterAuth user (server or client shape) into an {@link AppSession}. */
export function toAppSession(user: {
  id: string;
  email: string;
  name: string;
  image?: string | null | undefined;
  emailVerified?: boolean | undefined;
}): AppSession {
  return {
    user: {
      id: user.id,
      email: user.email,
      name: user.name,
      image: user.image ?? null,
      emailVerified: user.emailVerified ?? false,
    },
  };
}
